export default __webpack_public_path__ + "static/video-icon-d81b35e8f8473537f81b3d99eb1ac43d.png";